/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push as pushRouter } from 'react-router-redux';
import * as authActions from '../../redux/modules/auth';


class Logout extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { user, logout, push } = this.props;
      if (user) {
          logout();
      }else {
          push('/');
      }
  }

  render() {
    return (
      <div
        className="row"
        style={{
          width: '100vw',
          height: '100vh',
          backgroundColor: '#f4f3ef',
        }}
      >
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-10 login-card">
          <div className="card" style={{ paddingBottom: '15px' }}>
            <div className="header">
              <h4
                className="title"
                style={{ textAlign: 'center', color: 'green' }}
              >
                <i
                  className="fa fa-check"
                  style={{
                    width: '25px',
                    height: '25px',
                    borderRadius: '100%',
                    border: '1px solid green',
                  }}
                />
                {' '}
                                ÇIKIŞ YAPILDI
              </h4>
            </div>
          </div>
          <small className="text-center" style={{ display: 'block' }}>
                        ©
            {new Date().getFullYear()}
            {' '}
                        All Rights Reserved. Privacy and Terms
          </small>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});
const actions = { ...authActions, pushRouter };

export default connect(mapStateToProps, actions)(Logout);



// WEBPACK FOOTER //
// ./src/pages/logout/index.js